module.exports = __webpack_public_path__ + "media/images/color_admin_v3/transparent/black-0.3-58b07c75261d6debb22e60c5ef4b7dc0.png";